import { useEffect, useState } from 'react';
import { fetchNearbyLandmarks } from '../utils/mapLandmarks';

export const useMapLandmarks = ({ lat, lng, city, enabled = true, radius = 8000 }) => {
  const [landmarks, setLandmarks] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setLandmarks([]);
      return undefined;
    }

    let cancelled = false;
    setLoading(true);

    fetchNearbyLandmarks({ lat, lng, city, radius }).then((data) => {
      if (!cancelled) {
        setLandmarks(data);
        setLoading(false);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [lat, lng, city, enabled, radius]);

  return { landmarks, loadingLandmarks: loading };
};

export default useMapLandmarks;
